import { render, staticRenderFns } from "./GroupPurchaseInput.vue?vue&type=template&id=6e65fb24&scoped=true&"
import script from "./GroupPurchaseInput.vue?vue&type=script&lang=ts&"
export * from "./GroupPurchaseInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e65fb24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
